import React from "react";

const StatsSection = () => {
  return (
    <div
      className="section-full  site-bg-white twm-w-range-section-wrap wow fadeInDown"
      data-wow-offset="100"
      data-wow-delay="0.2s"
    >
      <div className="container">

        {/* TITLE START */}
        <div className="section-head center">
          <div className="twm-sm-title left">
            Trusted Cab & Travel Services
          </div>

          <h2 className="twm-large-title site-text-dark">
            Comfortable Rides With Shivai Travels
          </h2>
        </div>
        {/* TITLE END */}

        <div className="section-content">
          <div className="row twm-w-range-section">

            {/* One block */}
            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="twm-cntr-with-icon">
                <div className="icon-media">
                  <img src="images/icons/rental.png" alt="Trips Completed" />
                </div>

                <span className="counter">5000</span>{" "}
                <em className="symble">+</em>

                <h3 className="icon-content-info">
                  Trips Completed
                </h3>
              </div>
            </div>

            {/* Two block */}
            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="twm-cntr-with-icon">
                <div className="icon-media">
                  <img src="images/icons/man.png" alt="Happy Customers" />
                </div>

                <span className="counter">3500</span>{" "}
                <em className="symble">+</em>

                <h3 className="icon-content-info">
                  Happy Customers
                </h3>
              </div>
            </div>

            {/* Three block */}
            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="twm-cntr-with-icon">
                <div className="icon-media">
                  <img src="images/icons/car-insurance.png" alt="Fleet Vehicles" />
                </div>

                <span className="counter">150</span>{" "}
                <em className="symble">+</em>

                <h3 className="icon-content-info">
                  Vehicles Available
                </h3>
              </div>
            </div>

            {/* Four block */}
            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="twm-cntr-with-icon">
                <div className="icon-media">
                  <img src="images/icons/work-time.png" alt="Years Experience" />
                </div>

                <span className="counter">10</span>{" "}
                <em className="symble">+</em>

                <h3 className="icon-content-info">
                  Years Of Experience
                </h3>
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
  );
};

export default StatsSection;